import { useTranslation } from 'react-i18next'
import { Box, MenuItem } from '@mui/material'
import keys from '@/utils/keys'

import { TransactionTypePayment } from '@/enums/transaction-type-payment.enum'
import InputFormikField from '@/views/components/input-formik-field/index.component'

type Props = {
  handleChangeSearch: (field: string, value: any) => void
}

const BalanceFilterType = ({ handleChangeSearch }: Props) => {
  const { t } = useTranslation()

  const transactionTypePayment = [
    ...keys(TransactionTypePayment)
      .filter((item) => typeof TransactionTypePayment[item] !== 'string')
      .map((x) => {
        return {
          index: TransactionTypePayment[x],
          value: x,
        }
      }),
  ].sort((a, b) => a.value.localeCompare(b.value))

  const transactionTypePaymentOptions = transactionTypePayment.map((report) => {
    return (
      <MenuItem key={report.index} value={report.index}>
        {t(`reports.transactionTypePayment.${report.value}`)}
      </MenuItem>
    )
  })

  return (
    <InputFormikField
      name="transactionTypePayment"
      label={t('labels.transactionTypePayment')}
      select
      margin="dense"
      onChange={(event) =>
        handleChangeSearch('transactionTypePayment', event.target.value)
      }
    >
      <MenuItem value="all">
        <Box fontStyle="italic">{t('all')}</Box>
      </MenuItem>
      {transactionTypePaymentOptions}
    </InputFormikField>
  )
}
export default BalanceFilterType
